import jwt_decode from "jwt-decode";
import { auth } from "../firebase/firebase.utils";
import events from "../events";
import * as fbq from "../facebook-pixel/facebook-pixel";
import { apiGateway } from "./config";
import Cookies from "js-cookie";
import { v4 as uuidv4 } from "uuid";
import CryptoJS from "crypto-js";
import { toast } from "react-toastify";
import slugify from "slugify";

export const getTheToken = async () => {
  try {
    return new Promise((reslove, reject) => {
      const token = localStorage.getItem("token");

      if (token) {
        const decoded = jwt_decode(token);
        const expiration_time = decoded.exp * 1000;

        var currentTime = new Date().getTime();
        if (expiration_time - currentTime > 10000) {
          reslove(token);
          return;
        }
      }

      console.log("no token");
      localStorage.removeItem("token");
      console.log("token deleted");
      console.log("getting the token");
      auth.onAuthStateChanged((userAuth) => {
        if (userAuth) {
          userAuth
            .getIdToken(/* forceRefresh */ true)
            .then(function (idToken) {
              console.log("setting the token");
              localStorage.setItem("token", idToken);
              reslove(idToken);
            })
            .catch(function (error) {
              reject();
            });
        } else {
          localStorage.removeItem("user");
          auth.signInAnonymously().then(() => {
            console.log("signed in anonymously");
            window.location.reload();
          });
        }
      });
    });
  } catch (err) {
    console.error("ERROR!! getTheToken", err.message);
    alert(err);
  }
};

export const copyToClipboard = (text, cb) => {
  navigator.clipboard.writeText(text).then(
    function () {
      cb("success");
    },
    function (err) {
      cb("failed");
    }
  );
};

export const changeAnchor = (anchor, classes) => {
  switch (anchor) {
    case "left":
      return classes.left;
    case "right":
      return classes.right;
    default:
      return classes.left;
  }
};

// Common event function for Download, When user clicks on download the App CTA
export const handleDownloadAppEvent = ({
  user,
  webViewEvent,
  source_screen,
}) => {
  if (window) {
    window.dataLayer = window.dataLayer || [];
    const eventParams = {
      firebase_uid: user?.uid,
      date_time: new Date(),
      source_screen: source_screen,
    };
    if (webViewEvent) {
      eventParams.userAgent = webViewEvent?.userAgent;
      eventParams.mobile = webViewEvent?.mobile;
      eventParams.webview = true;
    }
    window.dataLayer.push({
      event: events.download_apk,
      ...eventParams,
    });
    fbq.event(events.download_apk, eventParams);
  }
};

export function autoReadSMS(callBackForOTP) {
  // used AbortController with setTimeout so that WebOTP API (Autoread sms) will get disabled after 1min
  const signal = new AbortController();
  setTimeout(() => {
    signal.abort();
  }, 1 * 60 * 1000);
  async function main() {
    if ("OTPCredential" in window) {
      try {
        if (navigator.credentials) {
          try {
            await navigator.credentials
              .get({ abort: signal, otp: { transport: ["sms"] } })
              .then((content) => {
                if (content && content.code) {
                  callBackForOTP(content?.code);
                }
              })
              .catch((e) => {
                console.log(e);
              });
          } catch (e) {
            return;
          }
        }
      } catch (err) {
        console.log(err);
      }
    }
  }
  main();
}

const handleLogOutAPICall = async ({ axiosPrivate }) => {
  try {
    const url = `${apiGateway}/api/v1/auth/logout/`;
    const response = await axiosPrivate.post(url);
    if (response?.status === 200) {
      Object.keys(Cookies.get()).forEach(function (cookieName) {
        Cookies.remove(cookieName);
      });
    }
    return response?.status;
  } catch (error) {
    toast.error(error?.message || "Something went wrong!!");
  }
};

export const handleLogout = async ({ type, axiosPrivate, setIsLoading }) => {
  // removed first_session cookie set by fresh_chat that was causing issue
  Cookies.remove("first_session", {
    path: "/",
  });
  if (type === "refresh_token") {
    localStorage.clear();
    Object.keys(Cookies.get()).forEach(function (cookieName) {
      Cookies.remove(cookieName);
    });
    if (setIsLoading) setIsLoading(false);
    window.location.reload();
  } else {
    const isLogoutStatus = await handleLogOutAPICall({ axiosPrivate });
    if (isLogoutStatus === 200) {
      localStorage.clear();
      auth
        .signOut()
        .then(() => {
          window.location.reload();
        })
        .catch(() => {
          toast.error("Something went wrong");
        });
    }
  }
};

const encryptAES = (inputText, key) => {
  // 1. Generate a random IV
  const iv = CryptoJS.lib.WordArray.random(128 / 8);

  // 2. Prepare the data and key
  const data = CryptoJS.enc.Utf8.parse(inputText);
  const keyBytes = CryptoJS.enc.Utf8.parse(key);

  // 3. Create the cipher object in CBC mode with PKCS#7 padding
  const cipher = CryptoJS.AES.encrypt(data, keyBytes, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  // 4. Combine the IV and ciphertext into a single base64-encoded string
  const ciphertext = cipher.ciphertext;
  const combined = iv.concat(ciphertext);
  const base64Encoded = combined.toString(CryptoJS.enc.Base64);
  return base64Encoded;
};

export const generateEncryptedString = ({ secretKey }) => {
  const key = secretKey;
  const originalString = "SeekhoSendOtp|" + uuidv4();
  const encryptedString = encryptAES(originalString, key);
  return encryptedString;
};

export const handleWebPageOpenEvent = ({
  type,
  webviewEvent,
  firebase_uid,
  campaignDetails,
  client_ip,
  web_first_month_discount,
  anonId,
}) => {
  if (window) {
    window.dataLayer = window.dataLayer || [];
    const eventParams = {
      firebase_uid,
      url: window.location.href,
      type,
      date_time: new Date(),
      campaign_details: campaignDetails,
      client_ka_ip_address: client_ip,
      web_first_month_discount,
      anon_id: anonId,
    };
    if (webviewEvent) {
      eventParams.packageName = webviewEvent?.packageName;
      eventParams.userAgent = webviewEvent?.userAgent;
      eventParams.mobile = webviewEvent?.mobile;
      eventParams.webview = true;
    }
    window.dataLayer.push({
      event: events.WEBPAGE_OPEN,
      ...eventParams,
    });
    fbq.event(events.WEBPAGE_OPEN, eventParams);
  }
};

export const handleScrollTo = ({ ref }) => {
  const viewportHeight = window.innerHeight;
  const elementHeight = ref?.current?.offsetHeight;

  const scrollToPosition =
    ref?.current?.offsetTop - viewportHeight / 2 + elementHeight / 2;

  window.scrollTo({
    top: scrollToPosition,
    behavior: "smooth",
  });
};

export const handleGenerateRandomString = ({ length }) => {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  const charactersLength = characters.length;

  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  return result;
};

// Common function which takes array of series and return object of struct data of series
export const handleCommonSeriesStructData = ({ seriesData }) => {
  const data = {
    "@context": "https://schema.org/",
    "@type": "ItemList",
    itemListElement: seriesData?.map((series, index) => {
      return {
        "@type": "ListItem",
        position: index + 1,
        name: series?.display_title,
        url: `https://seekho.in/series/${series?.slug}`,
      };
    }),
  };
  return data;
};

export const handleReadMoreContentFeature = ({ content, readMore }) => {
  const maxCharacters = 200; // Maximum characters to show initially
  if (readMore) {
    return content;
  } else {
    return (
      content?.slice(0, maxCharacters) +
      (content?.length > maxCharacters ? "..." : "")
    );
  }
};

export const handleIsAuthenticated = () => {
  if (typeof window !== "undefined") {
    try {
      const token = localStorage.getItem("isLoggedIn");
      return !!token;
    } catch (e) {
      console.error("Access to localStorage is denied.", e);
      return false;
    }
  } else {
    return false;
  }
};

export const handleConvertSecondsToMinutes = ({ seconds }) => {
  const minutes = Math.floor(seconds / 60);
  // const remainingSeconds = seconds % 60;
  return `${minutes} ${minutes <= 1 ? "min" : "mins"}`;
};

// Helper function to convert seconds to ISO 8601 duration
export const handleSecondsToISO8601Duration = ({ duration }) => {
  const hours = Math.floor(duration / 3600);
  const minutes = Math.floor((duration % 3600) / 60);
  const secs = duration % 60;
  return `PT${hours ? hours + "H" : ""}${minutes ? minutes + "M" : ""}${
    secs ? secs + "S" : ""
  }`;
};

export const handleServeLocalAssetsCdn =
  process.env.NODE_ENV === "production" ? "https://cdn.seekho.in" : "";

export const isIPhone = () => {
  return (
    typeof navigator !== "undefined" &&
    /iPhone|iPad|iPod/i.test(navigator.userAgent)
  );
};

export const handleFormatDate = ({ dateInString, showTime = true }) => {
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];

  if (!dateInString) {
    return "-";
  }

  const dateused = new Date(Date.parse(dateInString));
  const month = months[dateused.getMonth()];
  const date = dateused.getDate();
  const year = dateused.getFullYear();
  const hours = dateused.getHours();
  let mins = dateused.getMinutes();
  // Pad minutes with leading zero if needed
  mins = mins < 10 ? `0${mins}` : mins;
  return `${date} ${month} ${year} ${showTime ? `at ${hours}:${mins}` : ""}  `;
};

// function which will add default profile, if user has no profile.
export const handleDefaultProfile = ({ userName }) => {
  if (!userName) {
    return "https://i.pinimg.com/originals/0d/64/98/0d64989794b1a4c9d89bff571d3d5842.jpg";
  }
  const url = `https://ui-avatars.com/api/?background=random&name=${userName}`;
  return url;
};

export const handleGenerateTOCAndContent = ({ html }) => {
  const toc = [];
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  // Select all headers in order
  const headings = doc.body.querySelectorAll("h1, h2, h3");

  headings.forEach((item, index) => {
    const hasBold =
      item.querySelector("strong") ||
      item.querySelector("b") ||
      getComputedStyle(item).fontWeight === "bold";

    if (!hasBold) {
      return;
    }

    const text = item.innerText;
    const id = slugify(text, { lower: true, strict: true }) + "-" + index;
    item.id = id;
    toc.push({ id, text, tag: item.tagName.toLowerCase() });
  });

  return { toc, html: doc.body.innerHTML };
};

export const handleScrollToTOC = ({ id }) => {
  const target = document.getElementById(id);
  if (!target) return;
  const targetPosition = target.getBoundingClientRect().top + window.scrollY;
  window.scrollTo({
    top: targetPosition - 140,
    behavior: "smooth",
  });
};

export const isMobileDevice = () => {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return false; // Running on server
  }

  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  return /Android|iPhone|iPad|iPod/i.test(userAgent);
};

export const handleHexToRgb = (hex, opacity) => {
  if (!hex) return "rgba(0,0,0,0)";
  const bigint = parseInt(hex.replace("#", ""), 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};
